import { css } from '@emotion/css';

import { type GrafanaTheme2 } from '@grafana/data';
import { Trans } from '@grafana/i18n';
import { reportInteraction } from '@grafana/runtime';
import { LinkButton, useStyles2 } from '@grafana/ui';
import { type ShareModalTabProps } from 'app/features/dashboard/components/ShareModal/types';
import { type DashboardModel } from 'app/features/dashboard/state/DashboardModel';
import { type DashboardScene } from 'app/features/dashboard-scene/scene/DashboardScene';

import { getNewReportUrl } from './utils/url';

interface Props extends Omit<ShareModalTabProps, 'dashboard'> {
  dashboard: DashboardModel | DashboardScene;
}
export const CreateReportTab = ({ dashboard, onDismiss }: Props) => {
  const styles = useStyles2(getStyles);

  function onClickCreateReport() {
    reportInteraction('dashboards_sharing_report_create_clicked');
    onDismiss && onDismiss();
  }

  return (
    <LinkButton href={getNewReportUrl(dashboard)} onClick={onClickCreateReport} className={styles.button}>
      <Trans i18nKey="reports.create-report-tab.create-report-using-this-dashboard">
        Create report using this dashboard
      </Trans>
    </LinkButton>
  );
};

const getStyles = (theme: GrafanaTheme2) => {
  return {
    button: css({
      marginRight: theme.spacing(2),
    }),
  };
};
